export enum Platform {
  apple = "apple",
  google = "google",
}
